import { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import LogContext from '../context/LogContext';

axios.defaults.withCredentials = true;
const backendUrl = process.env.REACT_APP_BACKEND_URL;
const adminUrl = process.env.REACT_APP_ADMIN_BACKEND_URL;

const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const myContext = useContext(LogContext);

  useEffect(() => {
    const authenticate = async () => {
      try {
        const response = await axios.get(`${backendUrl}/auth`, {
          withCredentials: true // Include cookies in the request
        });

        if (response.status === 200) {
          const data = response.data;
          myContext.updateUser(data.user);
          setIsAuthenticated(true);
        } else {
          myContext.updateUser(null);
          setIsAuthenticated(false);
        }
      } catch (error) {
        setIsAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };

    authenticate();
  }, []);

  return { isAuthenticated, loading };
};

export default useAuth;
